import React, { useEffect, useState } from "react";
import './Universitys.css'; // Optional: For custom styling
import Assets from "../../Assets/Assets";
import { useNavigate } from "react-router-dom";
import axios from "axios";

function Universitys() {
    const [universities, setUniversities] = useState([]);
    // console.log(universities)
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const Token = sessionStorage.getItem('Token')
    // Fetch university details from the API

    useEffect(() => {
        const fetchUniversities = async () => {
            const config = {
                headers: {
                    authtoken: Token,
                },
            };

            try {
                const response = await axios.get(
                    "https://api.libaonline.com/api/v1/university/details",
                    config
                );
                setUniversities(response.data?.data?.University_details || []);
            } catch (error) {
                setError(error.response?.data?.message || error.message);
            } finally {
                setLoading(false);
            }
        };

        fetchUniversities();
    }, [Token]);

    const handleNavigate = () => {
        navigate('/courses');
    };

    if (loading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>Error: {error}</div>;
    }

    return (
        <div className="container-fluid main_wrapper h-100 p-lg-3 p-md-2 p-sm-2">
            <h2 className="mb-4">Universities List</h2>

            <div className="row">
                {universities.map((university, index) => (
                    <div className="col-lg-4 col-md-6 col-sm-12 mb-4" key={index}>
                        <div className={university?.status === 1 ? "card fadecard" : "card"} style={{ height: "400px", padding: "10px" }}>
                            <div style={{ position: "relative" }}>
                                <div
                                    style={{
                                        backgroundColor: "white",
                                        position: "absolute",
                                        width: "100px",
                                        borderRadius: "10px",
                                        padding: "5px",
                                        top: "0",
                                        left: "0",
                                        textAlign: "center"
                                    }}
                                >
                                    <h5>{university?.sub_name}</h5>
                                </div>
                                <img
                                    style={{
                                        width: "100%",
                                        borderRadius: "10px",
                                        height: "200px"
                                    }}
                                    src={university.uni_logo} alt="background" />

                                <div className="card-body">
                                    <h5 className="card-title">{university.uni_name}</h5>
                                    <button
                                        className="btn btn-primary w-100 mt-5"
                                        onClick={handleNavigate}
                                        disabled={university?.status === 1}
                                    >
                                        Get Your Affiliate Link
                                    </button>

                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Universitys;